@if (cacheEnabled) {
<div class="ft-offline-status-wrap">
  <div class="ft-offline-status">
      <button type="button" id="btn-offline-status" class="offlineStatusItems" mat-icon-button [matMenuTriggerFor]="cacheEnabled ? offlineStatusMenu : null" aria-label="Offline Status" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()">
          <mat-icon [class.blink]="cloudIcon === 'cloud_sync'"
                    [class.green-icon]="cloudIcon === 'cloud_done'"
                    [class.red-icon]="cloudIcon === 'cloud_off'"
                    [class.orange-icon]="cloudIcon === 'cloud_operate_offline'">
              {{ cloudIcon }}
          </mat-icon>
      </button>

      <mat-menu #offlineStatusMenu="matMenu" panelClass="offline-status-menu-wrap" backdropClass="offline-status-menu-wrap">

              <div mat-menu-item class="go-offline-item">
              <div class="offline-flex"
                   [style.background-color]="isOffline ? 'orange' : '#555'"
                   (click)="toggleOffline($event)">
                  <mat-icon>{{ isOffline ? 'wifi' : 'wifi_off' }}</mat-icon>
                  <span>{{ isOffline ? 'Go Online' : 'Go Offline' }}</span>
              </div>
          </div>
          <mat-divider></mat-divider>
          <div mat-menu-item class="offline-flex">
              <div class="offline-flex">
                  <div class="offline-flex">
                      <mat-icon>sync</mat-icon>
                      <span>Pending sync count</span>
                  </div>
                  <mat-chip class="status-chip high">{{ offlineStatus?.pendingDocumentCount || 0 }}</mat-chip>
              </div>
          </div>
          <mat-divider></mat-divider>
          <div mat-menu-item class="offline-flex">
              <div class="offline-flex">
                  <div class="offline-flex">
                      <mat-icon>upload</mat-icon>
                      <span>Pending upload count</span>
                  </div>
                  <mat-chip class="status-chip high">{{ offlineStatus?.pendingUploadCount || 0 }}</mat-chip>
              </div>
          </div>

          <mat-divider></mat-divider>

          <div mat-menu-item class="offline-flex">
              <div class="offline-flex">
                  <div class="offline-flex">
                      <mat-icon>apps</mat-icon>
                      <span>Static Resources</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(appValue, offlineStatus?.appMaxCount)" class="status-chip">{{ getDisplayCount(appValue, offlineStatus?.appMaxCount) }}</mat-chip>
              </div>
          </div>
          <mat-divider></mat-divider>

          <div mat-menu-item class="offline-flex">
              <div class="offline-flex">
                  <div class="offline-flex">
                      <mat-icon>storage</mat-icon>
                      <span>Data Cache</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(dataValue, offlineStatus?.dataMaxCount)" class="status-chip">{{ getDisplayCount(dataValue, offlineStatus?.dataMaxCount) }}</mat-chip>
              </div>
          </div>
          <mat-divider></mat-divider>
          <div mat-menu-item class="offline-flex">
              <div class="offline-flex">
                  <div class="offline-flex">
                      <mat-icon>map</mat-icon>
                      <span>Map Tiles</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(mapValue, offlineStatus?.mapMaxCount)" class="status-chip">{{ getDisplayCount(mapValue, offlineStatus?.mapMaxCount) }}</mat-chip>
              </div>
          </div>
          <mat-divider></mat-divider>
          <div mat-menu-item class="offline-flex">
              <div class="offline-flex">
                  <div class="offline-flex">
                      <mat-icon>attach_file</mat-icon>
                      <span>Attached Files</span>
                  </div>
                  <mat-chip [ngClass]="getStatusClass(fileValue, offlineStatus?.fileMaxCount)" class="status-chip">{{ getDisplayCount(fileValue, offlineStatus?.fileMaxCount) }}</mat-chip>
              </div>
          </div>
          @if ((offlineStatus?.errorCacheAttachedFile?.length ?? 0) > 0) {
              <mat-divider></mat-divider>
              <div mat-menu-item class="offline-flex" [matMenuTriggerFor]="cacheErrors">
                  <div class="offline-flex">
                      <div class="offline-flex">
                          <mat-icon class="error-icon">error</mat-icon>
                          <span class="error-text">Attached File Errors</span>
                      </div>
                      <span class="count-value error-text">{{ offlineStatus?.errorCacheAttachedFile.length }}</span>
                  </div>
              </div>
          }

          @if ((offlineStatus?.errorOfflineChangesSyncDocs?.length ?? 0) > 0) {
              <mat-divider></mat-divider>

              <div mat-menu-item class="offline-flex" [matMenuTriggerFor]="syncErrors">
                  <div class="offline-flex">
                      <div class="offline-flex">
                          <mat-icon class="error-icon">sync_problem</mat-icon>
                          <span class="error-text">Sync Errors</span>
                      </div>
                      <span class="count-value error-text">{{ offlineStatus?.errorOfflineChangesSyncDocs.length }}</span>
                  </div>
              </div>
          }
      </mat-menu>
      <mat-menu #cacheErrors="matMenu" panelClass="offline-status-sub-menu-wrap">
          <div mat-menu-item (click)="$event.stopPropagation(); clearErrorCachingAttachedFiles()">
              <mat-icon>delete_sweep</mat-icon>
              <span>Clear Errors</span>
          </div>
          <mat-divider></mat-divider>
          @for (err of offlineStatus?.errorCacheAttachedFile; track $index) {
              <div mat-menu-item class="error-list-item">
                  <span class="error-item-text">{{ $index + 1 }}. {{ err }}</span>
              </div>
          }
      </mat-menu>

      <mat-menu #syncErrors="matMenu" panelClass="offline-status-sub-menu-wrap">
          <div mat-menu-item (click)="$event.stopPropagation(); clearErrorOfflineChangesSyncDocs()">
              <mat-icon>delete_sweep</mat-icon>
              <span>Clear Errors</span>
          </div>
          <mat-divider></mat-divider>
          @for (err of offlineStatus?.errorOfflineChangesSyncDocs; track $index) {
              <div mat-menu-item class="error-list-item">
                  <span class="error-item-text">{{ $index + 1 }}. {{ err }}</span>
              </div>
          }
      </mat-menu>
      <mat-card id="swUpdateProgressIndicator">
  <div class="cache-icon-wrap offline-flex">
    <div class="sw-update-label offline-flex">
      <span class="material-icons">system_update </span>
      <h5>App is being installed...</h5>
      <button mat-icon-button class="close-button" (click)="closeProgress();">
        <span class="material-icons">close</span>
      </button>
    </div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  </mat-card>
  </div>
</div>
}
